<div class="termianls-add" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button  mat-stroked-button (click)="sendForm()"  color="primary" [class.spinner]="processingRequest" [disabled]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="row">
      <h3>Dane </h3>
    </div>


  <div fxFlex="100">
    <app-dict-insurance-companies [multiple]="false" [required]="true" label="TU" [formControl]="insuranceCompanyControl"></app-dict-insurance-companies>
  </div>

  <div fxFlex="100" >
    <mat-form-field fxFlex="100" >
      <mat-label> Numer polisy </mat-label>
      <input [required]="true" name="policyNumber"  matInput placeholder="Numer polisy"   [formControl]="policyNumberControl" >
      <mat-error *ngIf="terminalForm.get('policyNumber').hasError('required')">To pole jest wymagane</mat-error>
      <mat-error></mat-error>
    </mat-form-field>
  </div>

  <div fxFlex="100" >
    <mat-form-field fxFlex="100">
      <mat-label>Numer rachunku bankowego</mat-label>
      <input
        prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
        matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387"
        [formControl]="accountNumberControl">
      <mat-error *ngIf="terminalForm.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
      <mat-error *ngIf="terminalForm.getError('vatPayerControl')">Numer rachunku bankowego jest inny niż w rejestrze płatników VAT</mat-error>
    </mat-form-field>
  </div>

  <div fxFlex="100" fxLayoutGap="15px" *ngIf="!terminalsObject.terminalsImportRow">
    <mat-form-field fxFlex="100">
      <mat-label>Kwota</mat-label>
      <input [required]="true" matInput placeholder="Kwota"   [formControl]="sumControl">
      <mat-error *ngIf="terminalForm.get('sum').hasError('required')">To pole jest wymagane</mat-error>
    </mat-form-field>

  </div>
  </mat-card>
  <div fxLayout="row" fxLayoutGap="15px">
    <button  mat-stroked-button (click)="sendForm()"  color="primary" [class.spinner]="processingRequest" [disabled]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
